const actions = {
  SET_USER: "SET_USER",
  SET_TOKEN: "SET_TOKEN",
  SET_LOADING: "SET_LOADING",
  SET_LOGGEDIN: "SET_LOGGEDIN",
  SET_MODULE: "SET_MODULE",
  SET_ROLE: "SET_ROLE",
  SET_PERMISSION: "SET_PERMISSION",
  SET_USER_LIST: "SET_USER_LIST",
  BATTERY_ID: "BATTERY_ID",
  SCAN_ID: "SCAN_ID",
  OEM: "OEM",
  OEM_MODEL: "OEM_MODEL",
  MODULE_DETAILS: "MODULE_DETAILS",
  SET_QIS_DATA: "SET_QIS_DATA",
  SET_SIDEBAR_ITEMS: "SET_SIDEBAR_ITEMS",
  setUser: (data) => {
    return {
      type: actions.SET_USER,
      data,
    };
  },
  setToken: (data) => {
    return {
      type: actions.SET_TOKEN,
      data,
    };
  },
  setLoading: (data) => {
    return {
      type: actions.SET_LOADING,
      data,
    };
  },
  setLoggedIn: (data) => {
    return {
      type: actions.SET_LOGGEDIN,
      data,
    };
  },
  setUserList: (data) => {
    return {
      type: actions.SET_USER_LIST,
      data,
    };
  },
  setRole: (data) => {
    return {
      type: actions.SET_ROLE,
      data,
    };
  },
  setPermission: (data) => {
    return {
      type: actions.SET_PERMISSION,
      data,
    };
  },
  setModule: (data) => {
    return {
      type: actions.SET_MODULE,
      data,
    };
  },
  setSidebarItems: (data) => {
    return {
      type: actions.SET_SIDEBAR_ITEMS,
      data,
    };
  },
};

export default actions;
